import { useCallback, useMemo } from 'react';
import { FormikHelpers } from 'formik';
import { message } from 'antd';

import { ImportDeclarationDto } from '../dto';
import { IImportDeclarationsExcelRepo, ImportDeclarationsExcelRepoType } from '../repos';
import { useService } from '@core/inversify-react';
import { HttpStatusCode } from '@core/http';

export const useImportDeclaration = () => {
  const importDeclarationsExcel = useService<IImportDeclarationsExcelRepo>(ImportDeclarationsExcelRepoType);

  const initialValues = useMemo<ImportDeclarationDto>(() => {
    return {
      file: null,
    };
  }, []);

  const onSubmit = useCallback(
    async (values: ImportDeclarationDto, helpers: FormikHelpers<ImportDeclarationDto>) => {
      helpers.setStatus(null);

      message.loading({ key: 1, content: 'Sənəd yüklənir' });
      const result = await importDeclarationsExcel.execute(values);
      message.destroy();

      if (result.status === HttpStatusCode.OK) {
        message.success(result.response);
      } else {
        message.error(result.response);
      }
    },
    [importDeclarationsExcel],
  );

  return { onSubmit, initialValues };
};
